import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material'

export interface GroupedFaqCategory {
    category: string
    items: { question: string; answer: string }[]
}

interface CategoryFaqProps {
    title: string
    groupedFaq: GroupedFaqCategory[]
}

const CategoryFaq: React.FC<CategoryFaqProps> = ({ title, groupedFaq }) => {
    return (
        <Box component="section" sx={{ mb: 3 }}>
            {title && (
                <Typography
                    component="h2"
                    variant="h6"
                    sx={{ fontWeight: 600, fontSize: { xs: '1rem', md: '1.25rem' }, mb: 2 }}
                >
                    {title}
                </Typography>
            )}
            {groupedFaq.map((group, i) => (
                <Box key={`${group.category}-${i}`} sx={{ mb: 2 }}>
                    <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: 600, textTransform: 'capitalize', mb: 1, color: 'text.primary' }}
                    >
                        {group.category}
                    </Typography>
                    {group.items.map((item, index) => (
                        <Accordion
                            key={index}
                            disableGutters
                            elevation={0}
                            sx={{
                                border: 1,
                                borderColor: 'grey.200',
                                '&:not(:last-child)': { mb: 0.5 },
                                '&:before': { display: 'none' }
                            }}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                    {item.question}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                    {item.answer}
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </Box>
            ))}
        </Box>
    )
}

export default CategoryFaq
export type { CategoryFaqProps }
